import { YARS } from '../../shell/yar/yarConfig.ts';
import './salesYar.css';

/**
 * The «فروش یار» character's face, cropped from the module assistant artwork,
 * for use inside buttons and headings (the same character the floating
 * assistant shows in this module).
 */
export function YarFace({ size = 22 }: { readonly size?: number }) {
  return (
    <span
      className="sales-yar-face"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${YARS.sales.image})`,
      }}
    />
  );
}

/** Two four-point sparkles (one large, one small) that spin while a job runs. */
export function SparkleLoader({ size = 56 }: { readonly size?: number }) {
  return (
    <svg
      className="sparkle-loader"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className="sparkle-loader__big"
        d="M40 8 C43 36 52 45 80 48 C52 51 43 60 40 88 C37 60 28 51 0 48 C28 45 37 36 40 8 Z"
        transform="translate(2 4)"
        fill="currentColor"
      />
      <path
        className="sparkle-loader__small"
        d="M80 6 C81.4 17 85 20.6 96 22 C85 23.4 81.4 27 80 38 C78.6 27 75 23.4 64 22 C75 20.6 78.6 17 80 6 Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Shown in the analysis tab while extraction + analysis is running. */
export function AnalyzingPanel() {
  return (
    <div className="call-base__analyzing" role="status" aria-live="polite">
      <SparkleLoader />
      <strong>در حال استخراج و تحلیل مکالمه…</strong>
      <small>
        فروش‌یار متن مکالمه را استخراج و تحلیل می‌کند. این کار ممکن است چند دقیقه طول بکشد؛ این
        پنجره را باز نگه دارید.
      </small>
    </div>
  );
}
